import TopBar from "../../components/topBar/TopBar";
import { Strings } from "../../utils/strings";
import "./CourtBooking.css";
import { isMobile } from "react-device-detect";
import { useCourtBooking } from "../../context/courtBookingContext";
import { StaticBackdropModal } from "../../components/modal/staticBackdropModal/StaticBackdropModal";
import { SelectDateAndTimeExpanded } from "../../components/selectDateAndTimeExpanded/SelectDateAndTimeExpanded";
import { observer } from "mobx-react-lite";
import {
  useCourtBookingStore,
  useMatchListStore,
  usePaymentStore,
  useSectionStore,
  useSelectCircleStore,
  useUserStore,
} from "../../stores/StoreContext";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import { SelectDateAndTimeCollapsed } from "../../components/selectDateAndTimeCollapsed/SelectDateAndTimeCollapsed";
import { SectionState } from "../../stores/SectionStore";
import { SelectCircleInitial } from "../../components/selectCircleInitial/SelectCircleInitial";
import { SelectCircleExpanded } from "../../components/selectCircleExpanded/SelectCircleExpanded";
import { SelectCircleCollapsed } from "../../components/selectCircleCollapsed/SelectCircleCollapsed";
import { PaymentInitial } from "../../components/paymentInitial/PaymentInitial";
import { useEffect } from "react";
import { Button } from "../../components/button/Button";
import { Colors } from "../../utils/colors";
import { useNavigate } from "react-router-dom";
import { IS_HIDE_TOP_BAR } from "../../utils/constants";
import { PaymentExpanded } from "../../components/paymentExpanded/PaymentExpanded";

const CourtBooking = observer(() => {
  const courtBookingStore = useCourtBookingStore();
  const sectionStore = useSectionStore();
  const userStore = useUserStore();
  const paymentStore = usePaymentStore();
  const selectCircleStore = useSelectCircleStore();
  const matchListStore = useMatchListStore();

  const navigate = useNavigate();
  useEffect(() => {
    return () => {
      sectionStore.resetStore();
      courtBookingStore.resetStore();
      paymentStore.resetStore();
      selectCircleStore.resetStore();
      matchListStore.getMatchList();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { userModel, onLogOut } = useCourtBooking();

  useEffect(() => {
    if (userStore.userModel === null && userModel) {
      userStore.userModel = userModel;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userModel]);

  const isCourtBookButtonDisabled = () => {
    return (
      !paymentStore.isPaymentSummaryReviewed ||
      !paymentStore.playerPricesMap.size ||
      courtBookingStore.selectedTimeSlots.length === 0
    );
  };

  // if (!userModel) {
  //   return <OverlayLoadingIndicator loading text="Please wait" />;
  // }

  return (
    <>
      <div
        style={{
          paddingBottom: 30,
          display: "flex",
          flexDirection: "column",
        }}>
        {!localStorage.getItem(IS_HIDE_TOP_BAR) ? (
          <TopBar
            isBack={isMobile}
            onLogout={() => {
              courtBookingStore.modalData = {
                visible: true,
                title: Strings.LOGOUT,
                children: Strings.LOGOUT_WARNING,
                btnText: Strings.LOGOUT,
                btnVariant: "outline-danger",
                headerIcon: <div />,
                onClose: () => {
                  courtBookingStore.modalData = undefined;
                },
                onAccept: () => {
                  courtBookingStore.modalData = undefined;
                  onLogOut();
                },
              };
            }}
            // onBookPro={onCoachAvailability}
          />
        ) : (
          <div style={{ height: 0 }} />
        )}
        <div
          style={{
            maxWidth: "450px",
            width: "100%",
            justifyContent: "center",
            alignSelf: "center",
            margin: "0 auto",
          }}>
          {sectionStore.dateTimeSectionState === SectionState.initial ||
          sectionStore.dateTimeSectionState === SectionState.expanded ? (
            <SelectDateAndTimeExpanded />
          ) : (
            <SelectDateAndTimeCollapsed />
          )}
          {sectionStore.circleSectionState === SectionState.initial ? (
            <SelectCircleInitial />
          ) : sectionStore.circleSectionState === SectionState.expanded ? (
            // selectCircleStore.isInitialExpanded ? (
            //   <DoYouHaveSecuredPlayer />
            // ) : (
            <SelectCircleExpanded />
          ) : (
            // )
            // TODO: Create Collapsed component
            <SelectCircleCollapsed />
          )}
          {sectionStore.paymentState === SectionState.initial ||
          sectionStore.paymentState === SectionState.collapsed ? (
            <PaymentInitial />
          ) : (
            <PaymentExpanded />
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}>
            <Button
              onPress={() => {
                courtBookingStore.bookCourt(navigate);
              }}
              btnStyle={{
                height: 56,
                width: "90%",
                backgroundColor: Colors.darkBrown,
                marginTop: 30,
                marginBottom: 20,
              }}
              disabled={isCourtBookButtonDisabled()}
              textStyle={{ color: "white", fontWeight: 600, fontSize: 14 }}
              text={"Book my court"}
            />
          </div>
        </div>
        <StaticBackdropModal
          show={courtBookingStore.modalData?.visible ?? false}
          handleOpen={courtBookingStore.modalData?.onAccept}
          handleClose={courtBookingStore.modalData?.onClose}
          title={courtBookingStore.modalData?.title}
          children={courtBookingStore.modalData?.children}
          btnText={courtBookingStore.modalData?.btnText}
          headerIcon={courtBookingStore.modalData?.headerIcon}
        />
        <LoadingIndicator loading={courtBookingStore.isLoading} />
      </div>
    </>
  );
});

export default CourtBooking;
